import React, { isValidElement } from 'react';
import { Route, RouteProps, Routes, RoutesProps } from 'react-router';
import ErrorBoundary from './ErrorBoundary';

type RoutesWithCatchProps = RoutesProps;

function addCatchToChildren(children: React.ReactNode) {
    return React.Children.map(children, (child) => {
        if (!isValidElement(child)) {
            return child;
        }
        if (child.type === Route) {
            const new_props = { ...child.props } as RouteProps;
            if (new_props.element) {
                new_props.element = <ErrorBoundary key={new_props.path}>{new_props.element}</ErrorBoundary>;
            }
            if (new_props.children) {
                new_props.children = addCatchToChildren(new_props.children as React.ReactNode);
            }
            return { ...child, props: new_props };
        }
        // <Routes> reads routes through Fragments, so a Fragment's routes need their boundaries too.
        if (child.type === React.Fragment) {
            const fragmentProps = child.props as { children?: React.ReactNode };
            return <React.Fragment key={child.key}>{addCatchToChildren(fragmentProps.children)}</React.Fragment>;
        }
        return child;
    });
}

// Renders a <Routes> component with each child route's element wraped in <ErrorBoundary/>
export default class RoutesWithCatch extends React.Component<RoutesWithCatchProps> {
    render() {
        const children = this.props.children;
        if (!children) return <Routes />;

        const caughtChildren = addCatchToChildren(children);
        return <Routes>{caughtChildren}</Routes>;
    }
}
